import { UnitOfMeasureOrigin } from "gen/company/models_pb"
import { Product_ProductUnitUsage } from "gen/product/models_pb"
import { IntegrationVendor } from "gen/proto/integration_vendor/models_pb"

import { Decimal } from "../../classes/decimal"
import { UUID } from "../../classes/uuid"

export interface UnitOfMeasure {
  id: UUID
  companyId: UUID
  createdAt: Date
  updatedAt: Date
  name: string
  code: string
  notes: string
  isActive: boolean
  origin: UnitOfMeasureOrigin
  integrationVendor: IntegrationVendor
}

export interface ProductUnitOfMeasureConversion {
  conversionFactor: Decimal
  unitOfMeasure?: UnitOfMeasure
  isEdiPurchasingFactor: boolean
}

export interface ProductUnitOfMeasureUsage {
  usage: Product_ProductUnitUsage
  unitOfMeasure?: UnitOfMeasure
}

export const ProductUnitUsageLabels = {
  [Product_ProductUnitUsage.STOCKING]: "Stocking",
  [Product_ProductUnitUsage.PRICING]: "Pricing",
  [Product_ProductUnitUsage.SALE]: "Sale",
  [Product_ProductUnitUsage.TRANSFER]: "Transfer",
  [Product_ProductUnitUsage.ORDER]: "Order",
} satisfies Record<Product_ProductUnitUsage, string>
